/**
 * VZ10 - a voz preferida de cada pessoa para a fala do Rimati no chat.
 *
 * Lista curada e fixa: só ids que a Speech API da OpenAI aceita para
 * `gpt-4o-mini-tts`. A web mostra os rótulos; a API recusa qualquer outro id.
 * A preferência é POR PESSOA (usuário dentro da empresa), nunca da empresa toda.
 */
export const VOZES_DO_RIMATI = [
  { id: 'cedar', rotulo: 'Cedro — masculina, natural' },
  { id: 'marin', rotulo: 'Marina — feminina, natural' },
  { id: 'ash', rotulo: 'Ash — masculina, clara' },
  { id: 'onyx', rotulo: 'Ônix — masculina, grave' },
  { id: 'coral', rotulo: 'Coral — feminina, calorosa' },
  { id: 'sage', rotulo: 'Sálvia — feminina, serena' },
] as const;

export type VozDoRimati = (typeof VOZES_DO_RIMATI)[number]['id'];
export const IDS_DE_VOZ_DO_RIMATI = VOZES_DO_RIMATI.map((v) => v.id) as [VozDoRimati, ...VozDoRimati[]];
export const VOZ_DO_RIMATI_PADRAO: VozDoRimati = 'cedar';

export function ehVozDoRimati(valor: unknown): valor is VozDoRimati {
  return typeof valor === 'string' && (IDS_DE_VOZ_DO_RIMATI as readonly string[]).includes(valor);
}

/**
 * Velocidade de reprodução, aplicada NO NAVEGADOR (`playbackRate` com o tom
 * preservado). O parâmetro `speed` da OpenAI não vale para `gpt-4o-mini-tts`.
 */
export const VELOCIDADES_DA_FALA = [
  { valor: 0.85, rotulo: 'Mais devagar' },
  { valor: 1, rotulo: 'Normal' },
  { valor: 1.15, rotulo: 'Um pouco mais rápido' },
  { valor: 1.3, rotulo: 'Rápido' },
] as const;

export type VelocidadeDaFala = (typeof VELOCIDADES_DA_FALA)[number]['valor'];
export const VELOCIDADE_DA_FALA_PADRAO: VelocidadeDaFala = 1;

export function ehVelocidadeDaFala(valor: unknown): valor is VelocidadeDaFala {
  return typeof valor === 'number' && VELOCIDADES_DA_FALA.some((v) => v.valor === valor);
}

/** Frase fixa da amostra de cada voz: gerada uma vez por voz no servidor e guardada. */
export const FRASE_DE_AMOSTRA_DA_VOZ = 'Oi! Eu sou o Rimati. Posso ler as respostas com esta voz.';

export interface PreferenciasDeVozDto {
  /** A voz que a pessoa escolheu; `null` = segue o padrão do ambiente. */
  voz: VozDoRimati | null;
  velocidade: VelocidadeDaFala;
  /** A voz que vale de fato (a escolhida ou a padrão do ambiente). */
  vozEfetiva: string;
  /** A fala está ligada neste ambiente (VOICE_CHAT_ENABLED e provedor registrados). */
  disponivel: boolean;
}

export interface AtualizarPreferenciasDeVozDto {
  voz?: VozDoRimati | null;
  velocidade?: VelocidadeDaFala;
}
